import { render, staticRenderFns } from "./EventDescriptions.vue?vue&type=template&id=501b7568&"
import script from "./EventDescriptions.vue?vue&type=script&lang=js&"
export * from "./EventDescriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports